import { useSelector } from 'react-redux'

import {
  selectApiKeys,
  selectExportTableApiKeys
} from 'redux/selectors/ApiKeys'

/**
 * Hook for export table api keys
 * @returns [apiKeys, fetched]
 */
export const useExportTableApiKeys = () => {
  return useSelector(selectExportTableApiKeys)
}

/**
 * Hook for all api keys
 * @returns { keys, fetched, accessTo }
 */
export const useApiKeys = () => {
  return useSelector(selectApiKeys)
}
